module.exports = __webpack_public_path__ + "img/j_1.534468ae.jpg";